/** Exact host match prevents redirect loops when served through CloudFront. */
export function getCanonicalWebUrl(location: {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}): string | undefined {
  const origin =
    location.hostname === 'partake.appli.partage.club'
      ? 'https://appli.we-partake.com'
      : location.hostname === 'partaki.appli.partage.club'
        ? 'https://partaki.we-partake.com'
        : undefined;
  return origin ? `${origin}${location.pathname}${location.search}${location.hash}` : undefined;
}
